var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"outWx"},[_c('img',{staticClass:"icon",attrs:{"src":require("./assets/tanhao_icon.png")}}),_c('div',{staticClass:"tips mt-18"},[_vm._v("请在微信客户端打开链接")])])
}]

export { render, staticRenderFns }